import {styled} from '@linaria/react';
import {ComponentType, PropsWithChildren} from 'react';
import {COLORS} from '../../../constants/colors';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../constants/typography';

export const baseCss = `
  font-weight: 500;
  letter-spacing: auto;
  color: ${COLORS.Black};
`;

export type Alignment = 'left' | 'center' | 'right' | 'justify';

export type TextProps = PropsWithChildren<{
  size?: keyof typeof FONT_SIZES;
  color?: keyof typeof COLORS | 'inherit';
  weight?: keyof typeof FONT_WEIGHTS;
  transform?: 'lowercase' | 'uppercase' | 'capitalize' | 'none';
  striked?: boolean;
  className?: string;
  as?: keyof JSX.IntrinsicElements | ComponentType<PropsWithChildren>;
  textAlignment?: Alignment;
  dangerouslySetInnerHTML?: {__html: string};
}>;

export const Text = styled.span<TextProps>`
  ${baseCss};
  font-size: ${({size = 'px14'}) => FONT_SIZES[size]};
  text-transform: ${props => props.transform ?? ''};

  color: ${props =>
    props.color === 'inherit' ? 'inherit' : COLORS[props.color ?? 'Black']};

  font-weight: ${props =>
    props.weight ? FONT_WEIGHTS[props.weight] : FONT_WEIGHTS.light};

  text-decoration: ${props => (props.striked ? 'line-through' : 'none')};
  text-align: ${props => props.textAlignment ?? 'inherit'};
`;
